"use client"
import { useCurrencies } from "@opensea/wallet"
import { parseAsJson, useQueryState } from "nuqs"
import { z } from "zod"

const schema = z.object({
  currency: z.string(),
  nativeCurrency: z.string(),
  min: z.float64().optional(),
  max: z.float64().optional(),
})

export function usePriceQueryParam(queryParam: string) {
  const [values, setValues] = useQueryState(
    queryParam,
    parseAsJson(schema.parse),
  )

  return { price: values, setPrice: setValues }
}

export function usePriceRangeQueryParamInUSD(queryParam: string) {
  const { currencies, getUsdPrice } = useCurrencies()

  const { price } = usePriceQueryParam(queryParam)

  if (!price) {
    return undefined
  }

  const priceCurrency = currencies.find(c => c.symbol === price.currency)

  let minPrice = price.min
  let maxPrice = price.max

  if (price.currency !== "USD" && priceCurrency) {
    minPrice = price.min
      ? Number(getUsdPrice(priceCurrency, price.min))
      : price.min
    maxPrice = price.max
      ? Number(getUsdPrice(priceCurrency, price.max))
      : price.max
  }

  return {
    min: minPrice,
    max: maxPrice,
  }
}

export function usePriceRangeQueryParamInNativeCurrency(queryParam: string) {
  const { currencies, getCurrencyPrice } = useCurrencies()

  const { price } = usePriceQueryParam(queryParam)

  if (!price) {
    return undefined
  }

  const priceCurrency = currencies.find(c => c.symbol === price.nativeCurrency)

  let minPrice = price.min
  let maxPrice = price.max

  if (price.currency === "USD" && priceCurrency) {
    minPrice = price.min
      ? Number(getCurrencyPrice(priceCurrency, price.min))
      : price.min
    maxPrice = price.max
      ? Number(getCurrencyPrice(priceCurrency, price.max))
      : price.max
  }

  return {
    min: minPrice,
    max: maxPrice,
  }
}
